import { handleActions } from 'redux-actions';

const initialState = {
    data: [],
    links: {},
    meta: {},
    page: 1,
    limit: 10,
    sort: '',
    sortBy: '',
    searchQuery: '',
    fetching: true,
    error: false,
}

export default handleActions({

    FETCH_VEHICLES: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: false,
        }
    },

    FETCH_VEHICLES_SUCCESS: (state, action) => {
        return {
            ...state,
            fetching: false,
            data: action.vehicles.data,
            links: action.vehicles.links,
            meta: action.vehicles.meta,
            page: action.vehicles.meta.current_page,
            limit: action.vehicles.meta.per_page,
            ...action.params
        }
    },

    FETCH_VEHICLES_FAIL: (state, action) => {
        return {
            ...state,
            fetching: false,
            error: true
        }
    },

}, initialState)